import React from "react";
import { connect } from "react-redux";
import { updatedata } from "../Redux/reduxflow/action";
import NativeInspectionCamera from "../components/NativeInspectionCamera";

function Camra({
  save_pics,
  setshowcamra,
  desktopTitle,
  desktopBadge,
  desktopLabel,
}) {
  return (
    <NativeInspectionCamera
      onCapture={async (url) => {
        await save_pics({ url });
        setshowcamra(false);
      }}
      onCancel={async () => {
        setshowcamra(false);
      }}
      cancelLabel="Cancel"
      hint="Photograph the detail for this answer, then tap capture."
      rotateDescription="Hold your phone horizontally to photograph this checklist item. Cancel returns to the question."
      desktopTitle={desktopTitle}
      desktopBadge={desktopBadge}
      desktopLabel={desktopLabel || "Checklist photo"}
    />
  );
}

const mapStateToProps = (state) => ({
  car_data: state.cardata.car_pics_data,
  loading: state.cardata.loading,
});
const mapDispatchToProps = (dispatch) => {
  return {
    updatedata: (response, variant_id) =>
      dispatch(updatedata(response, variant_id)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Camra);
